/**
 * Small badge chip used wherever a ticket / event badge needs to render.
 *
 * Accepts a `{ text, color }` payload — both produced server-side
 * (auto badges) or by the organizer (manual badges).
 *
 * Colors map to fixed Tailwind palettes so the visual identity stays
 * consistent across the homepage, event cards, ticket widget, and
 * organizer dashboards.
 */
import React from 'react';

const COLOR_MAP = {
  red:    'bg-red-500/15 text-red-300 border-red-500/40',
  orange: 'bg-orange-500/15 text-orange-300 border-orange-500/40',
  gold:   'bg-amber-500/15 text-amber-300 border-amber-500/40',
  green:  'bg-emerald-500/15 text-emerald-300 border-emerald-500/40',
  blue:   'bg-blue-500/15 text-blue-300 border-blue-500/40',
  purple: 'bg-purple-500/15 text-purple-300 border-purple-500/40',
  pink:   'bg-pink-500/15 text-pink-300 border-pink-500/40',
};

const SIZE_CLASSES = {
  xs: 'text-[9px] px-1.5 py-0.5',
  sm: 'text-[10px] px-2 py-0.5',
  md: 'text-xs px-2.5 py-1',
};

export default function TicketBadge({ badge, size = 'sm', className = '', testId }) {
  if (!badge || !badge.text) return null;
  const cls = COLOR_MAP[badge.color] || COLOR_MAP.gold;
  const sz = SIZE_CLASSES[size] || SIZE_CLASSES.sm;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-semibold uppercase tracking-wider ${cls} ${sz} ${className}`}
      data-testid={testId || `ticket-badge-${badge.code || 'manual'}`}
      title={badge.text}
    >
      {badge.text}
    </span>
  );
}
